import React, { FC, useCallback, useState } from "react"
import { observer } from "mobx-react-lite"
import { Appearance, ViewStyle, TouchableOpacity } from "react-native"
import { Button, Screen, Text, useAutoFeederPond } from "../../../../components"
import { color } from "../../../../theme"
import { CompositeScreenProps } from "@react-navigation/native"
import { Toast, View } from "native-base"
import { SafeAreaView } from "react-native-safe-area-context"
import MaterialIcons from "react-native-vector-icons/MaterialIcons"
import { goBack, navigate } from "../../../../navigators"
import { useStores } from "../../../../models"
import { translate } from "../../../../i18n"

const ROOT: ViewStyle = {
  backgroundColor: color.palette.white,
  flex: 1
}

const DOUBLE_BUTTON: ViewStyle = {
  width: "48%"
}

const BLUETOOTH_CARD = (borderColor): ViewStyle => ({
  flexDirection:"row",
  borderColor: borderColor,
  borderWidth: 1,
  borderRadius: 10,
  padding: 16,
  alignItems: "center"
})

export const WizardConectionSetupScreen: FC<{ colorScheme?: "light" | "dark" } & CompositeScreenProps<any, any>> = observer(function WizardConectionSetupScreen(props) {
  const { colorScheme = "light" || Appearance.getColorScheme() } = props
  const { autoFeederPond: model, setAutoFeederPond: setModel } = useAutoFeederPond()
  const {
    autoFeederPondStore: modelStore,
    autoFeederPondStore: { loading }
  } = useStores()
  const [isFailedConnect, setIsFailedConnect] = useState<boolean>(false)

  const connect = useCallback(async () => {
    console.log(model, 'model before')
    if (!model) return;
    modelStore.set('loading', true);
    await model.connect("bluetooth").catch((e) => {
      setIsFailedConnect(true)
      Toast.show({ title: translate('autoFeederPondDetailScreen.failedToConnect') })
      return null
    })
    if (model.isConnected) await model.commandSetDateTime()
    console.log(model, 'model')
    setModel(model)
    modelStore.set('loading', false);
  }, [model, modelStore, setModel])

  const handleSubmit = useCallback(() => {
    navigate('Home.Stack', 'Home.AutoFeederPond.Wizard.Connection.Wifi.Setup')
  }, [])

  const handleBack = useCallback(() => {
    goBack('Home.Stack')
  }, [])

  const BluetoothCard = useCallback(() => {
    const isConnectedTitle = model && model.isConnected ? translate("autoFeederPondEditScreen.connected") : translate("autoFeederPondCreateWizardScreen.bluetoothDisconnected")
    const connectingTitle = loading ? translate("autoFeederPondEditScreen.connecting") : isConnectedTitle
    const borderColor = model && model.isConnected ? color.primary : (isFailedConnect ? color.palette.red400 : color.palette.gray400)
    return (
      <TouchableOpacity style={BLUETOOTH_CARD(borderColor)} onPress={connect} disabled={model?.isConnected}>
        <MaterialIcons name="bluetooth-audio" size={24} color="#666666" />
        <View ml="16px">
          <Text tx="autoFeederPondCreateWizardScreen.bluetooth" preset="title4" color={color.palette.gray800} colorScheme={colorScheme} />
          <Text text={connectingTitle} preset="body3" color={color.palette.gray700} colorScheme={colorScheme} />
        </View>
      </TouchableOpacity>
    )
  }, [colorScheme, connect, isFailedConnect, loading, model])

  const ButtonContainer = useCallback(() => (
    <View flexDirection="row" alignItems="center" padding="16px" justifyContent="space-between" borderTopWidth={1} borderColor={color.palette.gray400}>
      <Button
        testID="jala:id/left-button"
        tx="common.back"
        colorScheme={colorScheme}
        // loading={loading}
        onPress={handleBack}
        style={DOUBLE_BUTTON}
        preset="outline"
      />
      <Button
        testID="jala:id/right-button"
        tx="common.next"
        colorScheme={colorScheme}
        disabled={!model || !model.isConnected}
        loading={loading}
        onPress={handleSubmit}
        style={DOUBLE_BUTTON}
      />
    </View>
  ), [colorScheme, handleBack, handleSubmit, loading, model])

  return (
    <Screen style={ROOT} preset="scroll" colorScheme={colorScheme}>
      <SafeAreaView />
      <View flex={1} px="16px">
        <Text preset="body2" text={`1/4: ${translate("autoFeederPondCreateWizardScreen.connectionSetup")}`} color={color.palette.gray800} mb="8px" />
        <View height="3px" backgroundColor={color.palette.gray300} borderRadius="5px">
          <View height="3px" backgroundColor={color.primary} width="25%" borderRadius="5px" />
        </View>
        <Text preset="title3" tx="autoFeederPondCreateWizardScreen.connectAsto" color={color.palette.gray900} mt="30px" />
        <Text preset="body2" tx="autoFeederPondCreateWizardScreen.connectAstoSubtitle" color={color.palette.gray700} mt="4px" mb="32px" />
        <BluetoothCard />
      </View>
      <ButtonContainer />
    </Screen>
  )
})
